import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { IoLocationOutline, IoCallOutline, IoShieldCheckmarkOutline } from "react-icons/io5";
import { MdOutlineAlternateEmail, MdOutlineLocalShipping } from "react-icons/md";
import { FaWhatsapp, FaCreditCard, FaChevronRight } from "react-icons/fa";
import WhatsAppButton from "./Whatsapp";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigate = () => {
    navigate("/");
  };

  const mapLink =
    "https://maps.app.goo.gl/uWdtNrHZ3uE1bAx8A";

  return (
    <>
      {/* Floating Quick Action Buttons */}
      {location.pathname !== "/" && (
        <div className="fixed point2 blink" onClick={handleNavigate} title="Quick Purchase">
          <img
            src={require("../../assets/images/quickpurchase.png")}
            className="img-fluid priceicn2 float-right"
            alt="special price"
          />
        </div>
      )}

      {location.pathname !== "/" && location.pathname !== "/products" && (
        <>
          <div className="fixed point" title="WhatsApp Us">
            <WhatsAppButton name="KING OF AMARAN CRACKERS" phoneNumber="+91 8610214826" />
          </div>
          <a href={mapLink} target="_blank" rel="noreferrer" title="Store Location">
            <div className="fixed point3" style={{ cursor: "pointer" }}>
              <img
                src={require("../../assets/images/googlelocation.png")}
                className="img-fluid priceicn float-left"
                alt="Store location"
              />
            </div>
          </a>
          <a href="tel:+918610214826" title="Call Us">
            <div className="fixed point4" style={{ cursor: "pointer" }}>
              <img
                src={require("../../assets/images/callicon.webp")}
                className="img-fluid priceicn float-left"
                alt="Call Us"
              />
            </div>
          </a>
        </>
      )}

      {/* Main Luxury Footer Section */}
      <footer
        className="footer-section position-relative pt-5 pb-4"
        style={{
          background: "linear-gradient(180deg, #0B132B 0%, #050B18 100%)",
          color: "#FFF8F0",
          borderTop: "4px solid #FFD700",
          boxShadow: "0 -10px 30px rgba(0, 0, 0, 0.35)",
        }}
      >
        <Container>
          {/* Trust Banner Strip */}
          <div
            className="p-3 mb-5 rounded-4 d-flex flex-wrap justify-content-around align-items-center gap-3"
            style={{
              background: "linear-gradient(135deg, rgba(16, 31, 66, 0.9) 0%, rgba(11, 19, 43, 0.95) 100%)",
              border: "1px solid rgba(255, 215, 0, 0.35)",
              backdropFilter: "blur(8px)",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
            }}
          >
            <div className="d-flex align-items-center gap-2">
              <IoShieldCheckmarkOutline size={26} color="#FBBF24" />
              <span className="fw-bold" style={{ color: "#FFF8F0", fontSize: "0.95rem" }}>
                100% Genuine Sivakasi Fireworks
              </span>
            </div>
            <div className="d-flex align-items-center gap-2">
              <MdOutlineLocalShipping size={26} color="#FBBF24" />
              <span className="fw-bold" style={{ color: "#FFF8F0", fontSize: "0.95rem" }}>
                Safe & Fast Transport Dispatch
              </span>
            </div>
            <div className="d-flex align-items-center gap-2">
              <FaCreditCard size={24} color="#FBBF24" />
              <span className="fw-bold" style={{ color: "#FFF8F0", fontSize: "0.95rem" }}>
                Wholesale & Retail Direct Factory Rates
              </span>
            </div>
          </div>

          <Row className="g-4 pb-4">
            {/* Column 1: Brand & Logo Showcase */}
            <Col lg={4} md={6} className="text-center text-md-start">
              <div className="d-flex flex-column align-items-center align-items-md-start">
                <div
                  className="mb-3 p-2 bg-white rounded-circle d-inline-block"
                  style={{
                    boxShadow: "0 8px 25px rgba(0, 31, 190, 0.35)",
                    border: "3px solid #001FBE",
                    width: "130px",
                    height: "130px",
                  }}
                >
                  <img
                    src={require("../../assets/images/logosm.png")}
                    alt="KING OF AMARAN CRACKERS Logo"
                    className="w-100 h-100 rounded-circle object-fit-contain"
                  />
                </div>
                <h4
                  className="fw-bold mb-1"
                  style={{
                    color: "#FBBF24",
                    fontFamily: "serif",
                    letterSpacing: "1px",
                    fontSize: "1.35rem",
                  }}
                >
                  KING OF AMARAN CRACKERS
                </h4>
                <p className="mb-2" style={{ color: "#FDE68A", fontSize: "0.88rem", fontWeight: "600" }}>
                  Group of Sathya Crackers World | Wholesale & Retail
                </p>
                <p className="small text-white-50" style={{ lineHeight: "1.6", maxWidth: "330px" }}>
                  Your premier Sivakasi fireworks partner bringing bright colors, sound, and safe celebrations
                  to families and events across India at unbeatable wholesale pricing.
                </p>
              </div>
            </Col>

            {/* Column 2: Quick Links */}
            <Col lg={2} md={6} sm={6}>
              <div className="ps-lg-3">
                <h5
                  className="fw-bold mb-3 pb-2 position-relative"
                  style={{
                    color: "#FBBF24",
                    fontSize: "1.1rem",
                    borderBottom: "2px solid rgba(245, 158, 11, 0.3)",
                  }}
                >
                  Quick Links
                </h5>
                <ul className="list-unstyled mb-0 d-flex flex-column gap-2">
                  <li>
                    <Link
                      to="/home"
                      className="d-flex align-items-center gap-1 text-white-50 text-decoration-none footer-nav-item"
                    >
                      <FaChevronRight size={11} color="#F59E0B" /> Home
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/about"
                      className="d-flex align-items-center gap-1 text-white-50 text-decoration-none footer-nav-item"
                    >
                      <FaChevronRight size={11} color="#F59E0B" /> About Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/"
                      className="d-flex align-items-center gap-1 text-decoration-none footer-nav-item fw-bold"
                      style={{ color: "#FCD34D" }}
                    >
                      <FaChevronRight size={11} color="#F59E0B" /> Price List 2026 💥
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/safetytips"
                      className="d-flex align-items-center gap-1 text-white-50 text-decoration-none footer-nav-item"
                    >
                      <FaChevronRight size={11} color="#F59E0B" /> Safety Tips
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/contactus"
                      className="d-flex align-items-center gap-1 text-white-50 text-decoration-none footer-nav-item"
                    >
                      <FaChevronRight size={11} color="#F59E0B" /> Contact Us
                    </Link>
                  </li>
                </ul>
              </div>
            </Col>

            {/* Column 3: Store & Reach Us */}
            <Col lg={3} md={6}>
              <h5
                className="fw-bold mb-3 pb-2 position-relative"
                style={{
                  color: "#FBBF24",
                  fontSize: "1.1rem",
                  borderBottom: "2px solid rgba(245, 158, 11, 0.3)",
                }}
              >
                Store & Reach Us
              </h5>
              <div className="d-flex flex-column gap-3">
                {/* Location */}
                <a
                  href={mapLink}
                  target="_blank"
                  rel="noreferrer"
                  className="text-decoration-none text-white-50 d-flex gap-2 align-items-start"
                >
                  <div
                    className="p-1 rounded-circle flex-shrink-0 d-flex align-items-center justify-content-center"
                    style={{ background: "#001FBE", border: "1px solid #FFD700", width: "32px", height: "32px" }}
                  >
                    <IoLocationOutline size={18} color="#FFD700" />
                  </div>
                  <div style={{ fontSize: "0.88rem", lineHeight: "1.4" }}>
                    <strong className="text-white d-block">Store Address:</strong>
                    148E, Sivakasi - Virudhunagar Main Road, Nethaji Nagar, Veera Chelliya Puram, Virudhunagar (Dt). - 626 001
                  </div>
                </a>

                {/* Call */}
                <div className="d-flex gap-2 align-items-start">
                  <div
                    className="p-1 rounded-circle flex-shrink-0 d-flex align-items-center justify-content-center"
                    style={{ background: "#001FBE", border: "1px solid #FFD700", width: "32px", height: "32px" }}
                  >
                    <IoCallOutline size={18} color="#FFD700" />
                  </div>
                  <div style={{ fontSize: "0.88rem" }}>
                    <strong className="text-white d-block">Phone Helpline:</strong>
                    <a href="tel:+918610214826" className="text-white-50 text-decoration-none d-inline-block me-2">
                      +91 86102 14826
                    </a>
                    <br />
                    <a href="tel:+919566902788" className="text-white-50 text-decoration-none d-inline-block">
                      +91 95669 02788
                    </a>
                  </div>
                </div>

                {/* WhatsApp */}
                <div className="d-flex gap-2 align-items-center">
                  <div
                    className="p-1 rounded-circle flex-shrink-0 d-flex align-items-center justify-content-center"
                    style={{ background: "#25D366", width: "32px", height: "32px" }}
                  >
                    <FaWhatsapp size={18} color="#FFFFFF" />
                  </div>
                  <div style={{ fontSize: "0.88rem" }}>
                    <a
                      href="https://wa.me/918610214826?text=Hello%20King%20Of%20Amaran%20Crackers"
                      target="_blank"
                      rel="noreferrer"
                      className="text-white text-decoration-none fw-bold"
                    >
                      WhatsApp: +91 86102 14826
                    </a>
                  </div>
                </div>

                {/* Email */}
                <div className="d-flex gap-2 align-items-center">
                  <div
                    className="p-1 rounded-circle flex-shrink-0 d-flex align-items-center justify-content-center"
                    style={{ background: "#7B0F1C", border: "1px solid #F59E0B", width: "32px", height: "32px" }}
                  >
                    <MdOutlineAlternateEmail size={18} color="#FBBF24" />
                  </div>
                  <div style={{ fontSize: "0.88rem" }}>
                    <a href="mailto:seeni382@gmail.com" className="text-white-50 text-decoration-none">
                      seeni382@gmail.com
                    </a>
                  </div>
                </div>
              </div>
            </Col>

            {/* Column 4: Payment & Location Map Link */}
            <Col lg={3} md={6}>
              <h5
                className="fw-bold mb-3 pb-2 position-relative"
                style={{
                  color: "#FBBF24",
                  fontSize: "1.1rem",
                  borderBottom: "2px solid rgba(245, 158, 11, 0.3)",
                }}
              >
                Payments & Maps
              </h5>
              <p className="small text-white-50 mb-3">
                We accept Google Pay, PhonePe, UPI & Net Banking. Direct dispatch with verified transport parcels.
              </p>
              <div className="d-flex flex-wrap gap-2 mb-3">
                <span
                  className="px-2 py-1 rounded small fw-bold"
                  style={{ background: "#7B0F1C", color: "#FBBF24", border: "1px solid #F59E0B" }}
                >
                  Google Pay
                </span>
                <span
                  className="px-2 py-1 rounded small fw-bold"
                  style={{ background: "#7B0F1C", color: "#FBBF24", border: "1px solid #F59E0B" }}
                >
                  PhonePe
                </span>
                <span
                  className="px-2 py-1 rounded small fw-bold"
                  style={{ background: "#7B0F1C", color: "#FBBF24", border: "1px solid #F59E0B" }}
                >
                  UPI
                </span>
                <span
                  className="px-2 py-1 rounded small fw-bold"
                  style={{ background: "#7B0F1C", color: "#FBBF24", border: "1px solid #F59E0B" }}
                >
                  Bank Transfer
                </span>
              </div>
              <a
                href={mapLink}
                target="_blank"
                rel="noreferrer"
                className="btn w-100 fw-bold py-2"
                style={{
                  background: "linear-gradient(135deg, #FFD700 0%, #F59E0B 100%)",
                  color: "#0B132B",
                  borderRadius: "8px",
                  boxShadow: "0 4px 15px rgba(255, 215, 0, 0.3)",
                }}
              >
                📍 View Sivakasi Location
              </a>
            </Col>
          </Row>
        </Container>

        {/* Bottom Copyright Strip */}
        <div
          className="pt-3 mt-3 text-center"
          style={{
            borderTop: "1px solid rgba(255, 215, 0, 0.2)",
            background: "#050B18",
          }}
        >
          <Container>
            <p className="mb-0 text-white-50 small">
              Copyright © 2026, <strong style={{ color: "#FBBF24" }}>KING OF AMARAN CRACKERS</strong>. All rights reserved.
              <span className="d-block d-sm-inline ms-sm-2">Virudhunagar (Dt), Tamil Nadu.</span>
            </p>
          </Container>
        </div>
      </footer>
    </>
  );
};

export default Footer;
